import { Helper } from '@/mixin/helper'

export default [
    // Service Home Page
    {
        path: '/maintenance/',
        name: 'Service',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance')
    },

    {
        path: '/maintenance/serviceschedule',
        name: 'List Service Schedule',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceschedule')
    },

    {
        path: '/maintenance/serviceschedule/addserviceschedule',
        name: 'Service Schedule New',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceschedule/addserviceschedule')
    },

    {
        path: '/maintenance/serviceschedule/addserviceschedule/fleetlist',
        name: 'Fleet List Schedule',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceschedule/addserviceschedule/fleetlist')
    },

    {
        path: '/maintenance/serviceschedule/fleetlist',
        name: 'List Fleet Service',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceschedule/fleetlist')
    },

    {
        path: '/maintenance/serviceschedule/fleetlistdetail',
        name: 'Fleet Service Detail',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceschedule/fleetlistdetail')
    },

    {
        path: '/maintenance/servicealert',
        name: 'List Service Alert',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/servicealert')
    },

    {
        path: '/maintenance/servicealert/servicealertdetail',
        name: 'Detail Service Alert',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/servicealert/servicealertdetail')
    },

    {
        path: '/maintenance/servicerequest',
        name: 'List Service Request',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/servicerequest')
    },

    {
        path: '/maintenance/serviceorder',
        name: 'List Service Order',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceorder')
    },

    {
        path: '/maintenance/serviceorder/servicehistory',
        name: 'Service History',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceorder/servicehistory')
    },

    {
        path: '/maintenance/serviceorder/serviceorderadd',
        name: 'Service Order New',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceorder/serviceorderadd')
    },

    {
        path: '/maintenance/serviceorder/serviceorderdetail',
        name: 'Service Order Detail',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import('@/router/views/maintenance/serviceorder/serviceorderdetail')
    },
]